export const GET_STORES_REQUEST = 'GET_STORES_REQUEST'
export const GET_STORES_SUCCESS = 'GET_STORES_SUCCESS'
export const GET_STORES_FAIL = 'GET_STORES_FAIL'
export const GET_STORE_REQUEST = 'GET_STORE_REQUEST'
export const GET_STORE_SUCCESS = 'GET_STORE_SUCCESS'
export const GET_STORE_FAIL = 'GET_STORE_FAIL'
export const GET_ALL_STORES_REQUEST = 'GET_ALL_STORES_REQUEST'
export const GET_ALL_STORES_SUCCESS = 'GET_ALL_STORES_SUCCESS'
export const GET_ALL_STORES_FAIL = 'GET_ALL_STORES_FAIL'

